import React, { FC, useMemo } from 'react';
import NcFileContent from '@components/common/NCFile';
import { Machine } from '@interfaces/machines';
import { View } from 'react-native';
import { WithColorProps } from '@styles/colors/types';
import { getNCFileFontConfig } from '@components/wallboard/helpers';

interface ActiveTileNCFileSnapshotProps extends Pick<WithColorProps, 'C'> {
  machine: Machine;
  tileHeight: number;
}

const ActiveTileNCFileSnapshot: FC<ActiveTileNCFileSnapshotProps> = ({ C, machine, tileHeight }) => {
  const ncFileContentFontConfig = useMemo(() => getNCFileFontConfig(tileHeight), [tileHeight]);

  return (
    <View style={{ flex: 1 }}>
      <NcFileContent
        {...{
          selectedItem: machine,
          shouldTakeNCFileDataFromMachine: true,
          onlyNCFileContent: true,
          shouldScroll: false,
          containerPaddingBottom: 0,
          errorTextStyles: { marginTop: 0, marginBottom: 0 },
          ncFileTextContainerStyle: { height: '100%' },
          shouldTruncate: true,
          truncateLines: 10,
          borderRadiusTop: false,
          C,
          backgroundColor: C('Picture/Light/Overlay'),
          singleColor: true,
          ncFileTextColor: C('Label/Light/Tertiary'),
          ncFileContentFontConfig,
          isPreview: true,
          withoutCollapsingFeatureAndStyles: true,
        }}
      />
    </View>
  );
};

export { ActiveTileNCFileSnapshot };
